<!--
    课程分享-课程批量授权
    作用：第一步：选择课包
    说明：版本3.0
-->
<template>
  <div class="table-demo">
    <el-table
      v-loading="isLoading"
      ref="table"
      :data="list"
      :height="tableHeight"
      fit
      row-key="id"
      highlight-current-row
      class="table"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        reserve-selection
        type="selection"
        width="55"
        align="center"
      />
      <el-table-column
        v-for="(item,index) in tableHead"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
        align="center"
      />
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="total"
      :current-page.sync="listQuery.current_page"
      :page-size="parseInt(listQuery.per_page)"
      :total="total"
      background
      layout="prev, pager, next"
      @current-change="getList(listQuery.per_page)"
    />
    <div class="bottom-btns">
      <el-button @click="$router.go(-1)">取 消</el-button>
      <el-button
        type="primary"
        @click="nextStep">下一步</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OnceStep',
  data() {
    return {
      total: 0,
      list: [],
      tableHeight: '100%', // table高度
      listQuery: { // 列表请求参数
        current_page: 1,
        per_page: 10,
      },
      isLoading: false,
      tableHead: [{
        prop: 'name',
        label: '课程名称',
      }, {
        prop: 'code',
        label: '课程编号',
      }, {
        prop: 'detail_count',
        label: '课时总时',
      }],
    };
  },
  mounted() {
    // this.list = JSON.parse(sessionStorage.getItem('volumeAuth'))
    this.list = this.$store.state.courseAuth;
    this.$refs.table.toggleAllSelection();
  },
  methods: {
    getList() {

    },
    handleSelectionChange(val) {
      this.$emit('update-couese', val);
    },
    nextStep() {
      this.$emit('nextStep');
    },
  },
};
</script>
<style lang="scss" scoped>
.table-demo{
    height: 100%;
    display: flex;
    flex-direction: column;
    .table{
        flex:1
    }
    .bottom-btns{
        margin-top: 20px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/volumeAuth/components/onceStep.vue